var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPrize)?_c('div',{staticClass:"prize"},[_vm._v("积分 "),_c('span',[_vm._v("+1")]),_vm._v(" 啦")]):_vm._e(),_vm._v(" "),(_vm.showPrize)?_c('div',{staticClass:"bg"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4719cfd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wxShare/wxShare.vue
// module id = null
// module chunks = 